export default {
  titles: {
    add: '新增通道配置',
    editor: '编辑通道配置',
    add1: '新增通道账号',
    editor1: '编辑通道账号'
  },

  label: {
    accountId: '收款账户ID',
    accountId1: '收款账户邮箱',
    accountName: '收款账户名称',
    accountPassword: '收款账户密码',
    owner: '账号拥有者',
    recipientCode: '收款渠道编码',
    recipientId: '收款渠道ID',
    recipientName: '设备编码', // 收款渠道名称
    updateAcct: '修改人账号',
    updateTime: '修改时间',
    todayTotal: '今日收款总额',
    yestodayTotal: '昨日收款总额',

    channelCode: '通道编码',
    accountNumber: '收款账户',
    channelType: '通道类型',
    channelName: '通道名称',
    id: '主键ID',
    createAcct: '创建人账号',
    createTime: '创建时间',
    dayQuota: '每日额度上限',
    monthQuota: '每月额度上限',
    name: '通道编码',
    serviceType: '服务类型',
    singleMaxLimit: '单笔转账最高金额',
    singleMinLimit: '单笔转账最低金额',
    status: '状态',
    action: '操作',
    h5Logo: 'h5 Logo',
    pcLogo: 'pc Logo',
    supported: '支持第三方',
    refresh: '刷新',
    info: '通道说明',
    sort: '排序'
  },
  rules: {
    id: '主键ID不能为空',
    name: '通道编码不能为空',

    channelCode: '通道编码不能为空',
    accountNumber: {
      empty: '收款账户不能为空',
      type: '收款账户必须为数字',
      min: '收款账户长度必须大于等于7',
      max: '收款账户长度必须小于等于32'
    },

    accountId: {
      empty: '收款账户ID不能为空',
      type: '收款账户ID格式必须为邮箱'
    },
    channelName: '通道名称不能为空',
    channelType: '通道类型必须选择',
    serviceType: '服务类型必须选择',
    createAcct: '创建账号不能为空',
    createTime: '创建时间必须选择',
    dayQuota: {
      empty: '每日额度上限不能为空',
      type: '每日额度上限必须为数字',
      match: '每日额度上限必须大于0'
    },
    singleMaxLimit: {
      empty: '单笔转账最高金额不能为空',
      type: '每日额度上限必须为数字',
      match: '单笔转账最高金额必须大于等于0',

      match1: '单笔转账最高金额必须大于单笔转账最低金额'
    },
    singleMinLimit: {
      empty: '单笔转账最低金额不能为空',
      type: '每日额度上限必须为数字',
      match: '单笔转账最低金额必须大于等于0'
    },
    monthQuota: {
      empty: '每月额度上限不能为空',
      type: '每日额度上限必须为数字',
      match: '每月额度上限必须大于每日额度上限'
    },
    accountName: {
      empty: '收款账户名称不能为空'
    },
    sort: {
      empty: '排序不能为空'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/channel.js